export default {
  googleAuthorizeTerms: "Este aplicativo não será compatível após 10 de março de 2023. Instale a nova versão do {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
